export const regionOptions = [
  { value: "northAmerica", label: "North America" },
  { value: "southAmerica", label: "South America" },
  { value: "unitedKingdom", label: "United Kingdom" },
  { value: "europe", label: "Europe" },
  { value: "africa", label: "Africa" },
  { value: "middleEast", label: "Middle East" },
  { value: "asia", label: "Asia" },
  { value: "australasia", label: "Australasia" },
];

export const countryOptions = [
  {
    "value": "antiguaandBarbuda",
    "label": "Antigua and Barbuda",
    "region": "northAmerica"
  },
  {
    "value": "bahamas",
    "label": "Bahamas",
    "region": "northAmerica"
  },
  {
    "value": "barbados",
    "label": "Barbados",
    "region": "northAmerica"
  },
  {
    "value": "canada",
    "label": "Canada",
    "region": "northAmerica"
  },
  {
    "value": "costaRica",
    "label": "Costa Rica",
    "region": "northAmerica"
  },
  {
    "value": "cuba",
    "label": "Cuba",
    "region": "northAmerica"
  },
  {
    "value": "dominica",
    "label": "Dominica",
    "region": "northAmerica"
  },
  {
    "value": "dominicanRepublic",
    "label": "Dominican Republic",
    "region": "northAmerica"
  },
  {
    "value": "jamaica",
    "label": "Jamaica",
    "region": "northAmerica"
  },
  {
    "value": "mexico",
    "label": "Mexico",
    "region": "northAmerica"
  },
  {
    "value": "saintKittsandNevis",
    "label": "Saint Kitts and Nevis",
    "region": "northAmerica"
  },
  {
    "value": "saintLucia",
    "label": "Saint Lucia",
    "region": "northAmerica"
  },
  {
    "value": "saintVincentandtheGrenadines",
    "label": "Saint Vincent and the Grenadines",
    "region": "northAmerica"
  },
  {
    "value": "trinidadandTobago",
    "label": "Trinidad and Tobago",
    "region": "northAmerica"
  },
  {
    "value": "unitedStates",
    "label": "United States",
    "region": "northAmerica"
  },
  {
    "value": "argentina",
    "label": "Argentina",
    "region": "southAmerica"
  },
  {
    "value": "brazil",
    "label": "Brazil",
    "region": "southAmerica"
  },
  {
    "value": "chile",
    "label": "Chile",
    "region": "southAmerica"
  },
  {
    "value": "colombia",
    "label": "Colombia",
    "region": "southAmerica"
  },
  {
    "value": "ecuador",
    "label": "Ecuador",
    "region": "southAmerica"
  },
  {
    "value": "peru",
    "label": "Peru",
    "region": "southAmerica"
  },
  {
    "value": "uruguay",
    "label": "Uruguay",
    "region": "southAmerica"
  },
  {
    "value": "venezuela",
    "label": "Venezuela",
    "region": "southAmerica"
  },
  {
    "value": "england",
    "label": "England",
    "region": "unitedKingdom"
  },
  {
    "value": "scotland",
    "label": "Scotland",
    "region": "unitedKingdom"
  },
  {
    "value": "wales",
    "label": "Wales",
    "region": "unitedKingdom"
  },
  {
    "value": "northernIreland",
    "label": "Northern Ireland",
    "region": "unitedKingdom"
  },
  {
    "value": "albania",
    "label": "Albania",
    "region": "europe"
  },
  {
    "value": "andorra",
    "label": "Andorra",
    "region": "europe"
  },
  {
    "value": "armenia",
    "label": "Armenia",
    "region": "europe"
  },
  {
    "value": "austria",
    "label": "Austria",
    "region": "europe"
  },
  {
    "value": "azerbaijan",
    "label": "Azerbaijan",
    "region": "europe"
  },
  {
    "value": "belgium",
    "label": "Belgium",
    "region": "europe"
  },
  {
    "value": "bulgaria",
    "label": "Bulgaria",
    "region": "europe"
  },
  {
    "value": "croatia",
    "label": "Croatia",
    "region": "europe"
  },
  {
    "value": "cyprus",
    "label": "Cyprus",
    "region": "europe"
  },
  {
    "value": "czechRepublic",
    "label": "Czech Republic",
    "region": "europe"
  },
  {
    "value": "denmark",
    "label": "Denmark",
    "region": "europe"
  },
  {
    "value": "estonia",
    "label": "Estonia",
    "region": "europe"
  },
  {
    "value": "finland",
    "label": "Finland",
    "region": "europe"
  },
  {
    "value": "france",
    "label": "France",
    "region": "europe"
  },
  {
    "value": "georgia",
    "label": "Georgia",
    "region": "europe"
  },
  {
    "value": "germany",
    "label": "Germany",
    "region": "europe"
  },
  {
    "value": "greece",
    "label": "Greece",
    "region": "europe"
  },
  {
    "value": "hungary",
    "label": "Hungary",
    "region": "europe"
  },
  {
    "value": "iceland",
    "label": "Iceland",
    "region": "europe"
  },
  {
    "value": "ireland",
    "label": "Ireland",
    "region": "europe"
  },
  {
    "value": "italy",
    "label": "Italy",
    "region": "europe"
  },
  {
    "value": "kazakhstan",
    "label": "Kazakhstan",
    "region": "europe"
  },
  {
    "value": "latvia",
    "label": "Latvia",
    "region": "europe"
  },
  {
    "value": "liechtenstein",
    "label": "Liechtenstein",
    "region": "europe"
  },
  {
    "value": "lithuania",
    "label": "Lithuania",
    "region": "europe"
  },
  {
    "value": "luxembourg",
    "label": "Luxembourg",
    "region": "europe"
  },
  {
    "value": "malta",
    "label": "Malta",
    "region": "europe"
  },
  {
    "value": "moldova",
    "label": "Moldova",
    "region": "europe"
  },
  {
    "value": "monaco",
    "label": "Monaco",
    "region": "europe"
  },
  {
    "value": "montenegro",
    "label": "Montenegro",
    "region": "europe"
  },
  {
    "value": "netherlands",
    "label": "Netherlands",
    "region": "europe"
  },
  {
    "value": "norway",
    "label": "Norway",
    "region": "europe"
  },
  {
    "value": "poland",
    "label": "Poland",
    "region": "europe"
  },
  {
    "value": "portugal",
    "label": "Portugal",
    "region": "europe"
  },
  {
    "value": "romania",
    "label": "Romania",
    "region": "europe"
  },
  {
    "value": "sanMarino",
    "label": "San Marino",
    "region": "europe"
  },
  {
    "value": "serbia",
    "label": "Serbia",
    "region": "europe"
  },
  {
    "value": "slovakia",
    "label": "Slovakia",
    "region": "europe"
  },
  {
    "value": "slovenia",
    "label": "Slovenia",
    "region": "europe"
  },
  {
    "value": "spain",
    "label": "Spain",
    "region": "europe"
  },
  {
    "value": "sweden",
    "label": "Sweden",
    "region": "europe"
  },
  {
    "value": "switzerland",
    "label": "Switzerland",
    "region": "europe"
  },
  {
    "value": "vaticanCity",
    "label": "Vatican City",
    "region": "europe"
  },
  {
    "value": "egypt",
    "label": "Egypt",
    "region": "africa"
  },
  {
    "value": "kenya",
    "label": "Kenya",
    "region": "africa"
  },
  {
    "value": "madagascar",
    "label": "Madagascar",
    "region": "africa"
  },
  {
    "value": "mauritania",
    "label": "Mauritania",
    "region": "africa"
  },
  {
    "value": "mauritius",
    "label": "Mauritius",
    "region": "africa"
  },
  {
    "value": "morocco",
    "label": "Morocco",
    "region": "africa"
  },
  {
    "value": "nigeria",
    "label": "Nigeria",
    "region": "africa"
  },
  {
    "value": "southAfrica",
    "label": "South Africa",
    "region": "africa"
  },
  {
    "value": "israel",
    "label": "Israel",
    "region": "middleEast"
  },
  {
    "value": "kuwait",
    "label": "Kuwait",
    "region": "middleEast"
  },
  {
    "value": "oman",
    "label": "Oman",
    "region": "middleEast"
  },
  {
    "value": "qatar",
    "label": "Qatar",
    "region": "middleEast"
  },
  {
    "value": "saudiArabia",
    "label": "Saudi Arabia",
    "region": "middleEast"
  },
  {
    "value": "turkey",
    "label": "Turkey",
    "region": "middleEast"
  },
  {
    "value": "unitedArabEmirates",
    "label": "United Arab Emirates",
    "region": "middleEast"
  },
  {
    "value": "bangladesh",
    "label": "Bangladesh",
    "region": "asia"
  },
  {
    "value": "brunei",
    "label": "Brunei",
    "region": "asia"
  },
  {
    "value": "china",
    "label": "China",
    "region": "asia"
  },
  {
    "value": "india",
    "label": "India",
    "region": "asia"
  },
  {
    "value": "japan",
    "label": "Japan",
    "region": "asia"
  },
  {
    "value": "maldives",
    "label": "Maldives",
    "region": "asia"
  },
  {
    "value": "singapore",
    "label": "Singapore",
    "region": "asia"
  },
  {
    "value": "southKorea",
    "label": "South Korea",
    "region": "asia"
  },
  {
    "value": "taiwan",
    "label": "Taiwan",
    "region": "asia"
  },
  {
    "value": "australia",
    "label": "Australia",
    "region": "australasia"
  },
  {
    "value": "newZealand",
    "label": "New Zealand",
    "region": "australasia"
  },
];

export const usaStates = [
  { value: "alabama", label: "Alabama" },
  { value: "alaska", label: "Alaska" },
  { value: "arizona", label: "Arizona" },
  { value: "arkansas", label: "Arkansas" },
  { value: "california", label: "California" },
  { value: "colorado", label: "Colorado" },
  { value: "connecticut", label: "Connecticut" },
  { value: "delaware", label: "Delaware" },
  { value: "districtOfColumbia", label: "District of Columbia" },
  { value: "florida", label: "Florida" },
  { value: "georgia", label: "Georgia" },
  { value: "hawaii", label: "Hawaii" },
  { value: "idaho", label: "Idaho" },
  { value: "illinois", label: "Illinois" },
  { value: "indiana", label: "Indiana" },
  { value: "iowa", label: "Iowa" },
  { value: "kansas", label: "Kansas" },
  { value: "kentucky", label: "Kentucky" },
  { value: "louisiana", label: "Louisiana" },
  { value: "maine", label: "Maine" },
  { value: "maryland", label: "Maryland" },
  { value: "massachusetts", label: "Massachusetts" },
  { value: "michigan", label: "Michigan" },
  { value: "minnesota", label: "Minnesota" },
  { value: "mississippi", label: "Mississippi" },
  { value: "missouri", label: "Missouri" },
  { value: "montana", label: "Montana" },
  { value: "nebraska", label: "Nebraska" },
  { value: "nevada", label: "Nevada" },
  { value: "newHampshire", label: "New Hampshire" },
  { value: "newJersey", label: "New Jersey" },
  { value: "newMexico", label: "New Mexico" },
  { value: "newYork", label: "New York" },
  { value: "northCarolina", label: "North Carolina" },
  { value: "northDakota", label: "North Dakota" },
  { value: "ohio", label: "Ohio" },
  { value: "oklahoma", label: "Oklahoma" },
  { value: "oregon", label: "Oregon" },
  { value: "pennsylvania", label: "Pennsylvania" },
  { value: "rhodeIsland", label: "Rhode Island" },
  { value: "southCarolina", label: "South Carolina" },
  { value: "southDakota", label: "South Dakota" },
  { value: "tennessee", label: "Tennessee" },
  { value: "texas", label: "Texas" },
  { value: "utah", label: "Utah" },
  { value: "vermont", label: "Vermont" },
  { value: "virginia", label: "Virginia" },
  { value: "washington", label: "Washington" },
  { value: "westVirginia", label: "West Virginia" },
  { value: "wisconsin", label: "Wisconsin" },
  { value: "wyoming", label: "Wyoming" }
];
